import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Services from "./pages/Services";
import GDPR from "./pages/GDPR";
import OurProjects from "./pages/OurProjects";
import ContactUs from "./pages/ContactUs";
import ReportingChannel from "./pages/ReportingChannel";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Error404 from "./pages/Error404";
import QualityPolicyPage from "./pages/qualityPolicyPage/QualityPolicyPage";
import CompliancePolicyPage from "./pages/compliancePolicyPage/CompliancePolicyPage";
import ITServicesManagementPolicyPage from "./pages/iTServicesManagementPolicyPage/ITServicesManagementPolicyPage";
import EnvironmentalPolicyPage from "./pages/environmentalPolicyPage/EnvironmentalPolicyPage";
import HealthAndSafetyPolicyAtWorkPage from "./pages/healthAndSafetyPolicyAtWorkPage/HealthAndSafetyPolicyAtWorkPage";
import AntiBriberyPolicyPage from "./pages/antiBriberyPolicyPage/AntiBriberyPolicyPage";
import ViolenceAndHarassmentPolicyPage from "./pages/violenceAndHarassmentPolicyPage/ViolenceAndHarassmentPolicyPage";
import RecordManagementPolicyPage from "./pages/recordManagementPolicyPage/RecordManagementPolicyPage";
import BusinessContinuityPolicyPage from "./pages/businessContinuityPolicyPage/BusinessContinuityPolicyPage";
import InformationSecurityPolicyPage from "./pages/informationSecurityPolicyPage/InformationSecurityPolicyPage";
import PersonalDataSecurityPolicyPage from "./pages/personalDataSecurityPolicyPage/PersonalDataSecurityPolicyPage";
import EnergyPolicyPage from "./pages/energyPolicyPage/EnergyPolicyPage";
import InformationSystemsAcceptableUsePolicyPage from "./pages/informationSystemsAcceptableUsePolicyPage/InformationSystemsAcceptableUsePolicyPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="services" element={<Services />} />
            <Route path="services/gdpr" element={<GDPR />} />
            <Route path="our-projects" element={<OurProjects />} />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="reporting-channel" element={<ReportingChannel />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="quality-policy" element={<QualityPolicyPage />} />
            <Route
              path="it-services-management-policy"
              element={<ITServicesManagementPolicyPage />}
            />
            <Route
              path="compliance-policy"
              element={<CompliancePolicyPage />}
            />
            <Route
              path="environmental-policy"
              element={<EnvironmentalPolicyPage />}
            />
            <Route
              path="health-and-safety-policy-at-work"
              element={<HealthAndSafetyPolicyAtWorkPage />}
            />
            <Route
              path="anti-bribery-policy"
              element={<AntiBriberyPolicyPage />}
            />
            <Route
              path="violence-and-harassment-policy"
              element={<ViolenceAndHarassmentPolicyPage />}
            />
            <Route
              path="record-management-policy"
              element={<RecordManagementPolicyPage />}
            />
            <Route
              path="business-continuity-policy"
              element={<BusinessContinuityPolicyPage />}
            />
            <Route
              path="information-security-policy"
              element={<InformationSecurityPolicyPage />}
            />
            <Route
              path="personal-data-security-policy"
              element={<PersonalDataSecurityPolicyPage />}
            />
            <Route path="energy-policy" element={<EnergyPolicyPage />} />
            <Route
              path="information-systems-acceptable-use-policy"
              element={<InformationSystemsAcceptableUsePolicyPage />}
            />

            <Route path="*" element={<Error404 />} />
          </Route>
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
